module.exports = __webpack_public_path__ + "img/add-picture.3d31f986.png";